import styled from "@emotion/styled";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

const GCTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#008f7b",
    //border: "1px solid blue"
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    border: `1px solid #008f7b88`, //green
    borderRadius: "8px",
    marginBottom: "4px",
  },
}));

export default GCTooltip;
